export default __webpack_public_path__ + "static/media/logo-1.cc709676.png";